import script from "./InvestorRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestorRegistration.vue?vue&type=script&setup=true&lang=js"

import "./InvestorRegistration.vue?vue&type=style&index=0&id=a55d02c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a55d02c2"]])

export default __exports__